var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container search-results-container" },
    [
      _c("h1", { staticClass: "search-results__header" }, [
        _vm._v("Suggested Products"),
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.hasSearch
          ? _c(
              "div",
              [
                _c("h2", { staticClass: "search-results__subheader" }, [
                  _vm._v(
                    "Showing " +
                      _vm._s(_vm.searchResults.length) +
                      ' results for "' +
                      _vm._s(_vm.searchTerm) +
                      '"'
                  ),
                ]),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.searchResults.length > 0
                    ? _c(
                        "div",
                        { staticClass: "search-results collection-grid" },
                        [
                          _c(
                            "div",
                            { staticClass: "row small-up-2 medium-up-4" },
                            _vm._l(_vm.searchResults, function (item) {
                              return _c(
                                "div",
                                { staticClass: "column" },
                                [
                                  _c("product-tile", {
                                    attrs: { product: item },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "search-results__no-results" },
                        [
                          _c(
                            "h2",
                            { staticClass: "search-results__subheader" },
                            [
                              _vm._v(
                                "No products to show. Please enter a different search term."
                              ),
                            ]
                          ),
                          _c("link-button", {
                            staticClass: "search-results__cta",
                            attrs: {
                              label: "Start Shopping",
                              href: _vm.getShopNowLink,
                            },
                          }),
                        ],
                        1
                      ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }